// Authentic Google glyphs used in WorkspaceCard + Connections panel.
// Ported from project/duralex-prototype-v2.html — same SVGs, typed.

interface Props {
  kind: string;
  size?: number;
}

export function GIcon({ kind, size = 22 }: Props) {
  const s = size;
  if (kind === "gmail") {
    return (
      <svg viewBox="0 0 48 48" width={s} height={s}>
        <path
          fill="#fff"
          d="M5 14a3 3 0 0 1 3-3h32a3 3 0 0 1 3 3v22a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V14z"
        />
        <path fill="#4285F4" d="M5 14v22a3 3 0 0 0 3 3h4V18.5L5 14z" />
        <path fill="#EA4335" d="M5 14l19 14 19-14a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3z" />
        <path fill="#FBBC04" d="M36 18.5V39h4a3 3 0 0 0 3-3V14l-7 4.5z" />
        <path fill="#C5221F" d="M12 18.5L24 28l12-9.5V11l-12 9-12-9v7.5z" />
      </svg>
    );
  }
  if (kind === "drive") {
    return (
      <svg viewBox="0 0 48 48" width={s} height={s}>
        <path fill="#FBBC04" d="M16 6h16l12 21H28L16 6z" />
        <path fill="#34A853" d="M4 27l8 14h24l-8-14H4z" />
        <path fill="#4285F4" d="M16 6L4 27l8 14L24 20 16 6z" />
      </svg>
    );
  }
  if (kind === "calendar") {
    return (
      <svg viewBox="0 0 48 48" width={s} height={s}>
        <rect
          x="6"
          y="8"
          width="36"
          height="34"
          rx="3"
          fill="#fff"
          stroke="#dadce0"
          strokeWidth="1"
        />
        <rect x="6" y="8" width="36" height="8" rx="3" fill="#4285F4" />
        <rect x="13" y="4" width="3" height="9" rx="1.5" fill="#1a73e8" />
        <rect x="32" y="4" width="3" height="9" rx="1.5" fill="#1a73e8" />
        <text x="24" y="35" textAnchor="middle" fontSize="14" fontWeight="600" fill="#1a73e8">
          26
        </text>
      </svg>
    );
  }
  if (kind === "meet") {
    return (
      <svg viewBox="0 0 48 48" width={s} height={s}>
        <path fill="#00832d" d="M6 14a3 3 0 0 1 3-3h22v26H9a3 3 0 0 1-3-3V14z" />
        <path fill="#0066da" d="M31 18l8-5v22l-8-5v-12z" />
        <path fill="#e94235" d="M31 11h7a3 3 0 0 1 3 3v6l-10-4v-5z" />
        <path fill="#ffba00" d="M31 37v-5l10-4v6a3 3 0 0 1-3 3h-7z" />
      </svg>
    );
  }
  if (kind === "docs") {
    return (
      <svg viewBox="0 0 48 48" width={s} height={s}>
        <path
          fill="#4285F4"
          d="M30 4H12a3 3 0 0 0-3 3v34a3 3 0 0 0 3 3h24a3 3 0 0 0 3-3V13L30 4z"
        />
        <path fill="#a1c2fa" d="M30 4v6a3 3 0 0 0 3 3h6L30 4z" />
        <rect x="15" y="20" width="18" height="1.8" fill="#fff" />
        <rect x="15" y="25" width="18" height="1.8" fill="#fff" />
        <rect x="15" y="30" width="14" height="1.8" fill="#fff" />
      </svg>
    );
  }
  if (kind === "sheets") {
    return (
      <svg viewBox="0 0 48 48" width={s} height={s}>
        <path
          fill="#0F9D58"
          d="M30 4H12a3 3 0 0 0-3 3v34a3 3 0 0 0 3 3h24a3 3 0 0 0 3-3V13L30 4z"
        />
        <path fill="#87CEAC" d="M30 4v6a3 3 0 0 0 3 3h6L30 4z" />
        <rect x="15" y="20" width="18" height="14" fill="#fff" />
        <rect x="15" y="20" width="6" height="14" fill="#0F9D58" opacity="0.18" />
        <rect x="15" y="25" width="18" height="1" fill="#0F9D58" />
        <rect x="15" y="29" width="18" height="1" fill="#0F9D58" />
      </svg>
    );
  }
  if (kind === "contacts") {
    return (
      <svg viewBox="0 0 48 48" width={s} height={s}>
        <rect x="6" y="6" width="36" height="36" rx="4" fill="#4285F4" />
        <circle cx="24" cy="20" r="6" fill="#fff" />
        <path d="M12 36c0-6 5.4-10 12-10s12 4 12 10v2H12v-2z" fill="#fff" />
      </svg>
    );
  }
  return (
    <span
      className="icon-fallback"
      style={{ width: size, height: size, fontSize: Math.max(9, size / 3) }}
    >
      {String(kind || "??")
        .slice(0, 2)
        .toUpperCase()}
    </span>
  );
}
